// Frontend RBAC helper — mirrors backend PERMS. UI-only guard; server enforces.
const PERMS = {
  admin: ["*"],
  gestor: [
    "companies:*", "proteins:*", "preparations:*", "menus:*",
    "purchase:read", "export:read", "dashboard:read", "users:read",
  ],
  nutricionista: [
    "companies:read", "proteins:*", "preparations:*", "menus:*",
    "purchase:read", "export:read", "dashboard:read",
  ],
  visualizador: [
    "companies:read", "proteins:read", "preparations:read", "menus:read",
    "purchase:read", "export:read", "dashboard:read",
  ],
};

export const ROLE_LABELS = {
  admin: "Administrador",
  gestor: "Gestor",
  nutricionista: "Nutricionista",
  visualizador: "Visualizador",
};

export const ROLE_OPTIONS = [
  { value: "admin", label: "Administrador", description: "Acesso total, incluindo gestão de usuários" },
  { value: "gestor", label: "Gestor", description: "Gerencia empresas, proteínas, cardápios e compras" },
  { value: "nutricionista", label: "Nutricionista", description: "Cadastra proteínas e cardápios; leitura de empresas/compras" },
  { value: "visualizador", label: "Visualizador", description: "Somente leitura em todo o sistema" },
];

export function can(role, action) {
  if (!role) return false;
  const perms = PERMS[role] || [];
  if (perms.includes("*")) return true;
  if (perms.includes(action)) return true;
  const [resource, verb] = action.split(":");
  if (perms.includes(`${resource}:*`)) return true;
  if (perms.includes(`*:${verb}`)) return true;
  return false;
}

// Platform-scope check (super-admin cross-tenant)
export function isPlatformOwner(user) {
  return user?.platform_role === "owner";
}
